import { makeAutoObservable, runInAction } from 'mobx'
import { getPendingUserListToManageAsync} from '../../api/getPendingUserListToManage'

class PendingUserListToManage {
    error: string = "";
    isLoading: boolean = true;
    activeRequestId: number = 0;
    dataPending?: {
        users?: Array<{ email?: string; address?: string; property?: string }>;
        pageNum?: number;
        totalPage?: number;
        from?: number;
        to?: number;
        total?: number;
        search?: string;
    };
    isOpenModalCompleteRegistration: boolean = false;
    emailCompleteRegistration: string = "";

    constructor(){
        makeAutoObservable(this);
    }

    openModalCompleteRegistration = (email:string = "") => {
        runInAction(()=>{
            if(!this.isOpenModalCompleteRegistration){
                this.isOpenModalCompleteRegistration = true
            }
            this.emailCompleteRegistration = email
        })
        
    }

    closedModalCompleteRegistration = () => {
        runInAction(()=>{
            if(this.isOpenModalCompleteRegistration){
                this.isOpenModalCompleteRegistration = false
            }
            this.emailCompleteRegistration = ""
        })
        
    }

    getPendingUserListToManageAction = (search: string = null, page: number = null) => {
        const requestId = this.activeRequestId + 1;
        this.activeRequestId = requestId;
        if(!this.isLoading){
            this.isLoading = true;
        }
        let request;

        if(search != null && page != null){
            request = getPendingUserListToManageAsync(search,page)
        }else if (search != null && page == null){
            request = getPendingUserListToManageAsync(search)
        }else if(search == null && page != null){
            request = getPendingUserListToManageAsync("",page)
        }else{
            request = getPendingUserListToManageAsync()
        }

        return request.then(res=> {
            runInAction(() => {
                if (this.activeRequestId !== requestId) {
                    return
                }
                this.dataPending = res.data
                if(this.isLoading){
                    this.isLoading = false;
                }
            })
            return res
        }).catch(err => {
            runInAction(() => {
                if (this.activeRequestId !== requestId) {
                    return
                }
                this.error = err?.message ?? "Unable to load pending registrations."
                if(this.isLoading){
                    this.isLoading = false;
                }
            })
            return null
        })
    }

    completeRegistrationAction = (email: string) =>{
        console.log(email)
    }

}
export default PendingUserListToManage;
